import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback, UpdatePasswordParams } from 'types';

export const sendEmail = createAction('reset-password/send-email', (email: string) => ({
  payload: email,
}));

export const sendedEmail = createAction('reset-password/sended-email', (error?: RequestError) => ({
  payload: error,
  error: Boolean(error),
}));

export const updatePassword = createAction(
  'reset-password/update-password',
  (updatePasswordParams: UpdatePasswordParams, callback?: Callback<unknown, void>) => ({
    payload: updatePasswordParams,
    meta: { callback },
  })
);

export const updatedPassword = createAction(
  'reset-password/updated-password',
  (error?: RequestError, message?: string) => ({
    payload: { error, message },
    error: Boolean(error),
  })
);

export default {
  sendEmail,
  sendedEmail,
  updatePassword,
  updatedPassword,
};
